import { createReducer } from 'helpers/ReducerUtil'
import * as R from 'ramda'

import {
  ADD_RISK_CHECK,
  REMOVE_RISK_CHECK,
  CLEAR_RISK,
  UPDATE_VALUE,
  RISK_DEFAULT_VALUE,
  RISK_VALUE,
} from './constants'

const getInitialValue = () => [{ value: RISK_DEFAULT_VALUE }]
const getRiskValue = () => [{ value: RISK_VALUE }]

const clearRisk = () => ({})
const removeRiskCheck = (risks, { id }) => ({ ...risks, [id]: true })
const addRiskCheck = (risks, { id }) => ({ ...risks, [id]: false })
const updateValue = (prevValue, { value }) => value === false
  ? getInitialValue()
  : getRiskValue()

const riskValidationReducer = createReducer({}, {
  [CLEAR_RISK]: clearRisk,
  [ADD_RISK_CHECK]: addRiskCheck,
  [REMOVE_RISK_CHECK]: removeRiskCheck,
})

const riskReducer = createReducer(getInitialValue(), {
  [CLEAR_RISK]: getInitialValue,
  [UPDATE_VALUE]: updateValue
})

export {
  riskValidationReducer,
  riskReducer
}
